// common action types
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const ASYNC_START = "ASYNC_START";
export const ASYNC_END = "ASYNC_END";
export const STORE_TENANTS = "STORE_TENANTS";
export const SET_CURRENT_TENANT = "SET_CURRENT_TENANT";
export const REDIRECT = "REDIRECT";

// auth related action types
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const UPDATE_FIELD_AUTH = "UPDATE_FIELD_AUTH";
export const LOGIN_PAGE_UNLOADED = "LOGIN_PAGE_UNLOADED";
export const CLEAR_AUTH_ERRORS = "CLEAR_AUTH_ERRORS";

// bundles action types
export const SET_BUNDLES = "SET_BUNDLES";
export const SET_BUNDLES_FAILED = "SET_BUNDLES_FAILED";
export const BUNDLE_SAVED = "BUNDLE_SAVED";
export const BUNDLE_SAVE_FAILED = "BUNDLE_SAVE_FAILED";
export const UPDATE_BUNDLES_SEARCH = "UPDATE_BUNDLES_SEARCH";

// license bundles actions types
export const SET_LICENSE_BUNDLES = "SET_LICENSE_BUNDLES";
export const SET_LICENSE_BUNDLES_FAILED = "SET_LICENSE_BUNDLES_FAILED";
export const LICENSE_BUNDLE_SAVED = "LICENSE_BUNDLE_SAVED";
export const LICENSE_BUNDLE_SAVE_FAILED = "LICENSE_BUNDLE_SAVE_FAILED";
export const UPDATE_LICENSE_BUNDLES_SEARCH = "UPDATE_LICENSE_BUNDLES_SEARCH";

//features actions
export const SET_FEATURES = "SET_FEATURES";
export const SET_FEATURES_FAILED = "SET_FEATURES_FAILED";
export const FEATURE_SAVED = "FEATURE_SAVED";
export const FEATURE_SAVE_FAILED = "FEATURE_SAVED_FAILED";
export const UPDATE_FEATURE_SEARCH = "UPDATE_FEATURE_SEARCH";

// products actions types
export const PRODUCT_SAVED = "PRODUCT_SAVED";
export const PRODUCT_SAVE_STARTED = "PRODUCT_SAVE_STARTED";
export const PRODUCT_SAVE_FAILED = "PRODUCT_SAVE_FAILED";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SET_PRODUCT_OPTIONS = "SET_PRODUCT_OPTIONS";
export const SET_PRODUCTS_FAILED = "SET_PRODUCTS_FAILED";
export const PRODUCT_UPDATE_SUCCESS = "PRODUCT_UPDATE_SUCCESS";
export const PRODUCT_UPDATE_FAILED = "PRODUCT_UPDATE_FAILED";
export const FETCH_CUSTOMER_AVAILABLE_PRODUCTS_START = "FETCH_CUSTOMER_AVAILABLE_PRODUCTS_START";
export const FETCH_CUSTOMER_AVAILABLE_PRODUCTS_SUCCESS = "FETCH_CUSTOMER_AVAILABLE_PRODUCTS_SUCCESS";
export const FETCH_CUSTOMER_AVAILABLE_PRODUCTS_FAILED = "FETCH_CUSTOMER_AVAILABLE_PRODUCTS_FAILED";
export const FETCH_FILTERED_PRODUCT_BUNDLES_START = "FETCH_FILTERED_PRODUCT_BUNDLES_START";
export const FETCH_FILTERED_PRODUCT_BUNDLES_SUCCESS = "FETCH_FILTERED_PRODUCT_BUNDLES_SUCCESS";
export const FETCH_FILTERED_PRODUCT_BUNDLES_FAILED = "FETCH_FILTERED_PRODUCT_BUNDLES_FAILED";
export const FETCH_FILTERED_PRODUCT_LICENSE_BUNDLES_START = "FETCH_FILTERED_PRODUCT_LICENSE_BUNDLES_START";
export const FETCH_FILTERED_PRODUCT_LICENSE_BUNDLES_SUCCESS = "FETCH_FILTERED_PRODUCT_LICENSE_BUNDLES_SUCCESS";
export const FETCH_FILTERED_PRODUCT_LICENSE_BUNDLES_FAILED = "FETCH_FILTERED_PRODUCT_LICENSE_BUNDLES_FAILED";
export const FETCH_FILTERED_PRODUCT_NOT_ADDONS_START = "FETCH_FILTERED_PRODUCT_NOT_ADDONS_START";
export const FETCH_FILTERED_PRODUCT_NOT_ADDONS_SUCCESS = "FETCH_FILTERED_PRODUCT_NOT_ADDONS_SUCCESS";
export const FETCH_FILTERED_PRODUCT_NOT_ADDONS_FAILED = "FETCH_FILTERED_PRODUCT_NOT_ADDONS_FAILED";

// purchases action types
export const FETCH_PURCHASES_START = "FETCH_PURCHASES_START";
export const FETCH_PURCHASES_SUCCESS = "FETCH_PURCHASES_SUCCESS";
export const FETCH_PURCHASES_FAILED = "FETCH_PURCHASES_FAILED";

export const CANCEL_PURCHASE_SUCCESS = "CANCEL_PURCHASE_SUCCESS";
export const CANCEL_PURCHASE_FAILED = "CANCEL_PURCHASE_FAILED";

export const EXPIRE_PURCHASE_SUCCESS = "EXPIRE_PURCHASE_SUCCESS";
export const EXPIRE_PURCHASE_FAILED = "EXPIRE_PURCHASE_FAILED";

export const RENEW_PURCHASE_TOGGLE_SUCCESS = "RENEW_PURCHASE_TOGGLE_SUCCESS";
export const RENEW_PURCHASE_TOGGLE_FAILED = "RENEW_PURCHASE_TOGGLE_FAILED";

export const CREATE_PURCHASE_START = "CREATE_PURCHASE_START";
export const CREATE_PURCHASE_FAILED = "CREATE_PURCHASE_FAILED";
export const CREATE_PURCHASE_SUCCESS = "CREATE_PURCHASE_SUCCESS";

export const UPDATE_PURCHASE_START = "UPDATE_PURCHASE_START";
export const UPDATE_PURCHASE_SUCCESS = "UPDATE_PURCHASE_SUCCESS";
export const UPDATE_PURCHASE_FAILED = "UPDATE_PURCHASE_FAILED";

export const FETCH_CUSTOMER_ACTIVE_PURCHASES_START = "FETCH_CUSTOMER_ACTIVE_PURCHASES_START";
export const FETCH_CUSTOMER_ACTIVE_PURCHASES_SUCCESS = "FETCH_CUSTOMER_ACTIVE_PURCHASES_SUCCESS";
export const FETCH_CUSTOMER_ACTIVE_PURCHASES_NOT_OWNED_START = "FETCH_CUSTOMER_ACTIVE_PURCHASES_NOT_OWNED_START";
export const FETCH_CUSTOMER_ACTIVE_PURCHASES_NOT_OWNED_SUCCESS = "FETCH_CUSTOMER_ACTIVE_PURCHASES_NOT_OWNED_SUCCESS";
export const FETCH_CUSTOMER_BUNDLE_USAGES_START = "FETCH_CUSTOMER_BUNDLE_USAGES_START";
export const FETCH_CUSTOMER_BUNDLE_USAGES_SUCCESS = "FETCH_CUSTOMER_BUNDLE_USAGES_SUCCESS";
export const APPEND_PURCHASES_PAGE = "FETCH_APPEND_PURCHASES";
export const FETCH_PURCHASES_FILTERED_START = "FETCH_PURCHASES_FILTERED_START";
export const FETCH_CUSTOMER_ACTIVE_PURCHASES_FAILED = "FETCH_CUSTOMER_AVAILABLE_PURCHASES_FAILED";
export const FETCH_CUSTOMER_ACTIVE_PURCHASES_NOT_OWNED_FAILED = "FETCH_CUSTOMER_AVAILABLE_PURCHASES_NOT_OWNED_FAILED";
export const FETCH_CUSTOMER_BUNDLE_USAGES_FAILED = "FETCH_CUSTOMER_BUNDLE_USAGES_FAILED";
export const UPDATE_PURCHASES_PAGE_COUNT = "UPDATE_PURCHASES_PAGE_COUNT";

export const UPDATE_CUSTOMER_BUNDLE_USAGE_START = "UPDATE_CUSTOMER_BUNDLE_USAGE_START";
export const UPDATE_CUSTOMER_BUNDLE_USAGE_SUCCESS = "UPDATE_CUSTOMER_BUNDLE_USAGE_SUCCESS";
export const UPDATE_CUSTOMER_BUNDLE_USAGE_FAILED = "UPDATE_CUSTOMER_BUNDLE_USAGE_FAILED";

// product groups actions
export const FETCH_PRODUCT_GROUPS_SUCCESS = "FETCH_PRODUCT_GROUPS_SUCCESS";
export const FETCH_PRODUCT_GROUPS_FAILED = "FETCH_PRODUCT_GROUPS_FAILED";
export const SAVE_PRODUCT_GROUP_SUCCESS = "SAVED_PRODUCT_GROUP";
export const SAVE_PRODUCT_GROUP_FAILED = "SAVE_PRODUCT_GROUP_FAILED";

// customers actions
export const FETCH_CUSTOMERS_START = "FETCH_CUSTOMERS_START";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_FAILED = "FETCH_CUSTOMERS_FAILED";
export const APPEND_CUSTOMER_PAGE = "APPEND_CUSTOMER_PAGE";
export const FETCH_CUSTOMERS_FILTERED_START = "FETCH_CUSTOMERS_FILTERED_START";
export const UPDATE_CUSTOMER_PAGE_COUNT = "UPDATE_CUSTOMER_PAGE_COUNT";
export const FETCH_CUSTOMER_OPTIONS_START = "FETCH_CUSTOMER_OPTIONS_START";
export const FETCH_CUSTOMER_OPTIONS_SUCCESS = "FETCH_CUSTOMER_OPTIONS_SUCCESS";

// fetch owner options for subscription
export const FETCH_OWNER_OPTIONS_START = "FETCH_OWNER_OPTIONS_START";
export const FETCH_OWNER_OPTIONS_SUCCESS = "FETCH_OWNER_OPTIONS_SUCCESS";
export const FETCH_OWNER_OPTIONS_FAILED = "FETCH_OWNER_OPTIONS_FAILED";

// fetch vats options for tenant
export const FETCH_VATS_OPTIONS_START = "FETCH_VATS_OPTIONS_START";
export const FETCH_VATS_OPTIONS_SUCCESS = "FETCH_VATS_OPTIONS_SUCCESS";
export const FETCH_VATS_OPTIONS_FAILED = "FETCH_VATS_OPTIONS_FAILED";

//tenant creation and update
export const CREATE_TENANT_START = "CREATE_TENANT_START";
export const CREATE_TENANT_FAILED = "CREATE_TENANT_FAILED";
export const CREATE_TENANT_SUCCESS = "CREATE_TENANT_SUCCESS";
export const UPDATE_TENANT_START = "UPDATE_TENANT_START";
export const UPDATE_TENANT_SUCCESS = "UPDATE_TENANT_SUCCESS";
export const UPDATE_TENANT_FAILED = "UPDATE_TENANT_FAILED";
export const FETCH_CURRENCY_START = "FETCH_CURRENCY_START";
export const FETCH_CURRENCY_FAILED = "FETCH_CURRENCY_FAILED";
export const FETCH_CURRENCY_SUCCESS = "FETCH_CURRENCY_SUCCESS";
export const FETCH_CURRENCIES_TENANT_START = "FETCH_CURRENCIES_TENANT_START";
export const FETCH_CURRENCIES_TENANT_SUCCESS = "FETCH_CURRENCIES_TENANT_SUCCESS";
export const FETCH_CURRENCIES_TENANT_FAILED = "FETCH_CURRENCIES_TENANT_FAILED";

//export customers report for internal invoices
export const EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_START = "EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_START";
export const EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_SUCCESS = "EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_SUCCESS";
export const EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_FAILED = "EXPORT_CUSTOMERS_REPORT_FOR_INTERNAL_INVOICES_FAILED";

export const UPDATE_CUSTOMER_START = "UPDATE_CUSTOMER_START";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAILED = "UPDATE_CUSTOMER_FAILED";

// customer groups actions
export const FETCH_CUSTOMER_GROUPS_START = "FETCH_CUSTOMER_GROUPS_START";
export const FETCH_CUSTOMER_GROUPS_SUCCESS = "FETCH_CUSTOMER_GROUPS_SUCCESS";
export const FETCH_CUSTOMER_GROUPS_FAILED = "FETCH_CUSTOMER_GROUPS_FAILED";

// delete actions
export const FETCH_DELETE_SUMMARY_START = "FETCH_DELETE_SUMMARY_START";
export const FETCH_DELETE_SUMMARY_SUCCESS = "FETCH_DELETE_SUMMARY_SUCCESS";
export const FETCH_DELETE_SUMMARY_FAILED = "FETCH_DELETE_SUMMARY_FAILED";
export const DELETE_RECORD_SUCCESS = "DELETE_RECORD_SUCCESS";
export const DELETE_RECORD_FAILED = "DELETE_RECORD_FAILED";

// invoice actions
export const FETCH_INVOICES_START = "FETCH_INVOICES_START";
export const FETCH_INVOICES_SUCCESS = "FETCH_INVOICES_SUCCESS";
export const FETCH_INVOICES_FAILED = "FETCH_INVOICES_FAILED";

export const BACKEND_PROCESSING_ONGOING = "BACKEND_PROCESSING_ONGOING";
export const FETCH_IDS_START = "FETCH_IDS_START";
export const FETCH_IDS_SUCCESS = "FETCH_IDS_SUCCESS";
export const FETCH_START = "FETCH_START";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const FETCH_FAILED = "FETCH_FAILED";

export const UPDATE_RESOURCE_FIELDS = "UPDATE_RESOURCE_FIELDS";
export const PROMOTE_IN_PROGRESS_INVOICES = "PROMOTE_IN_PROGRESS_INVOICES";

export const SET_PAGE = "SET_PAGE";
export const CLEAR_INVOICES = "CLEAR_INVOICES";
